import { render, staticRenderFns } from "./Table.Average.vue?vue&type=template&id=28f6b56c&"
import script from "./Table.Average.vue?vue&type=script&lang=js&"
export * from "./Table.Average.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports